import axios from 'axios'
import { attachAuth } from './client'

/**
 * 보드(board) 앱 API. 같은 EDGE 토큰으로 부른다 — 플랫폼 Admin 토큰은 모든 앱 aud 를 갖고,
 * 회사 Manager 는 그 회사가 보드를 구독했을 때 board aud 를 갖는다(TokenService.ResolveApps).
 * 운영은 게이트웨이가 /board 를 보드로 넘기므로 같은 origin, dev 는 vite 프록시가 같은 모양을 만든다.
 */
const BOARD_BASE = (import.meta.env.VITE_BOARD_URL || '/board/').replace(/\/+$/, '') + '/api'

const board = attachAuth(axios.create({
  baseURL: BOARD_BASE,
  headers: { 'Content-Type': 'application/json' },
}))

/** 회사 단위 Teams 알림 설정 (보드가 저장한다 — 보드 배경 작업이 토큰 없이 읽어야 하므로) */
export interface TeamsNotifySettings {
  companyId: string
  enabled: boolean
  /** 이 회사에 저장된 워크플로 주소 (빈 값이면 보드 서버 기본값을 쓴다) */
  webhookUrl: string
  /** 실제로 발송에 쓰이는 주소 */
  effectiveWebhookUrl: string
  /** 메시지 링크에 쓰는 보드 주소 (보드 서버 설정, 읽기 전용) */
  webBaseUrl: string
  /** 보낼 주소가 있는가 — 없으면 켜도 아무것도 나가지 않는다 */
  configured: boolean
  updatedAt?: string
  updatedByUserId?: string
}

export const boardTeamsNotifyApi = {
  get: (companyId: string) =>
    board.get<TeamsNotifySettings>('/admin/teams-notify', { params: { companyId } }),
  save: (companyId: string, enabled: boolean, webhookUrl?: string) =>
    board.put<TeamsNotifySettings>('/admin/teams-notify', { enabled, webhookUrl }, { params: { companyId } }),
  /** 연결 확인 — 내 이메일로 테스트 메시지 1건 */
  test: (companyId: string) =>
    board.post<{ sent: boolean; email: string }>('/admin/teams-notify/test', null, { params: { companyId } }),
}

export default board
